module.exports = "<a class=\"creative__cta creative__cta--position-<%=position%> <%=media%>\" href=\"<%=link%>\" target=\"_blank\"><img src=\"<%=image%>\" alt></a>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./static/src/javascripts/projects/commercial/views/creatives/fabric-expandable-video-v2-cta.html
// module id = 581
// module chunks = 0